var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "upload-container",
      class: { "hide-upload": _vm.maxNumber === _vm._value.length },
    },
    [
      _c(
        "el-upload",
        {
          staticClass: "upload-con",
          attrs: {
            accept: "image/*",
            action: "#",
            limit: _vm.maxNumber,
            "file-list": _vm._value,
            "with-credentials": "",
            "auto-upload": true,
            multiple: _vm.maxNumber > 1,
            "list-type": "picture-card",
            "before-upload": _vm.beforeUpload,
            "http-request": _vm.uploadFile,
          },
          scopedSlots: _vm._u([
            {
              key: "file",
              fn: function ({ file }) {
                return _c("div", { staticClass: "upload-file" }, [
                  _c("img", {
                    staticClass: "el-upload-list__item-thumbnail",
                    attrs: { src: file.url, alt: "" },
                  }),
                  _c("span", { staticClass: "el-upload-list__item-actions" }, [
                    _c(
                      "span",
                      {
                        staticClass: "el-upload-list__item-preview",
                        on: {
                          click: function ($event) {
                            return _vm.handlePictureCardPreview(file)
                          },
                        },
                      },
                      [_c("i", { staticClass: "el-icon-zoom-in" })]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "el-upload-list__item-delete",
                        on: {
                          click: function ($event) {
                            return _vm.handleRemove(file)
                          },
                        },
                      },
                      [_c("i", { staticClass: "el-icon-delete" })]
                    ),
                  ]),
                ])
              },
            },
          ]),
        },
        [
          _vm.loading
            ? _c("i", {
                staticClass: "el-icon-loading primary-color",
                attrs: { slot: "default" },
                slot: "default",
              })
            : _c("i", {
                staticClass: "el-icon-plus",
                attrs: { slot: "default" },
                slot: "default",
              }),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, "append-to-body": "" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            attrs: {
              width: "100%",
              fit: "contain",
              src: _vm.dialogImageUrl,
              alt: "",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }